// extracted by mini-css-extract-plugin
module.exports = {"rowFlex":"XzCxciuHXe0qCgtx2CAq5g==","columnFlex":"WzsEYXUVR9nbSBEB-C+DmA==","wrapper":"L7Pz2GL+oyCyzMpFu4iMag==","alignText":"AUmOfLxKBXQDLoo+hQL6Aw=="};